import config from '@src/config';
import {createLogger} from './logger'


export default createLogger({ level: 'ALL' });
